/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { AnnouncementBannerItem } from './AnnouncementBannerItem';

const boxStyles = cssMap({
	default: {
		paddingTop: token('space.100'),
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		borderTopStyle: 'solid',
		borderTopWidth: token('border.width'),
		borderTopColor: token('color.border'),
	},
});

export interface AnnouncementBanner {
	id: string;
	text: string;
	onClose: () => void;
}

interface Props {
	banners: AnnouncementBanner[];
}

export function AnnouncementBanners({ banners }: Props) {
	if (banners.length === 0) {
		return null;
	}

	return (
		<Flex xcss={boxStyles.default} direction="column" gap="space.100">
			{banners.map((banner) => (
				<AnnouncementBannerItem key={banner.id} text={banner.text} onClose={banner.onClose} />
			))}
		</Flex>
	);
}
